<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <!--table-->
        <div>
          <div class="col-sm-12" id="divMainFilter">
            <div class="row">
              <div class="col-sm-4">
                <label>Status Type</label>
                <select id="ddlApprovedStatus" class="form-control">
                  <option selected value="All">All</option>
                  <option value="Approved">Approved</option>
                  <option value="Send to Approval">Send to Approval</option>
                  <option value="Waiting for Approval">Waiting for Approval</option>
                  <option value="Need More Info">Need More Info</option>
                </select>
              </div>
              <div class="col-sm-2">
                <label>From</label>
                <input type="date" name="FromDate" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
              </div>
              <div class="col-sm-2">
                <label>To</label>
                <input type="date" name="ToDate" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
              </div>

              <div class="col-sm-2">
                <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" id="btnLoadList" title="Get" (click)="GetweightageApprovalData()">Search</button>
                <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
              </div>
            </div>
          </div>
          <button type="button" id="BtnPopup" (click)="showWeightageApproval()" style="display:none">Search</button>
          <table #dataTable class="display" style="width:100%"></table>
        </div>

        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--Loader gif-->
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>

              <div class="modal-body" style="overflow-x:auto !important;">
                <div class="card">
                  <div class="card-body">

                    <div class="row">
                      <!-- Left Section - Old Weightage Performance -->
                      <div class="col-md-6">
                        <div class="form-group border p-3" style="max-height: 80vh; overflow-y: auto;">
                          <h5>Old Weightage Performance {{username}}</h5>
                          <br />
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Role</label>
                              <select id="ddlOldRoleType" disabled class="form-control">
                                <option *ngFor="let item of RoleList" [value]="item.RoleID">{{ item.RoleName }}</option>
                              </select>
                            </div>
                            <div class="col-sm-12">
                              <label>Non Production</label>
                              <input id="Txt_OldNonProduction" type="number" disabled class="form-control" max="100" min="0" />
                            </div>
                            <div class="col-sm-12">
                              <label>Productivity Achieved</label>
                              <input id="Txt_OldProductivityAchieved" disabled type="number" class="form-control" max="100" min="0" />
                            </div>
                            <div class="col-sm-12">
                              <label>Occupancy</label>
                              <input id="Txt_OldOccupancy" type="number" disabled class="form-control" max="100" min="0" />
                            </div>
                            <div class="col-sm-12">
                              <label>Punctuality</label>
                              <input id="Txt_OldPunctuality" type="number" disabled class="form-control" max="100" min="0" />
                            </div>
                            <div class="col-sm-12">
                              <label>Attendance</label>
                              <input id="Txt_OldAttendance" type="number" disabled class="form-control" max="100" min="0" />
                            </div>
                            <div class="col-sm-12">
                              <label>Total Sum</label>
                              <input id="Txt_OldTotalSum" type="number" class="form-control" disabled />
                            </div>
                            <div class="col-sm-12">
                              <label>Daily Target Pages</label>
                              <input id="Txt_OldDailyTargetPages" disabled type="number" class="form-control" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Right Section - New Weightage Performance -->
                      <div class="col-md-6">
                        <div class="form-group border p-3" style="max-height:80vh; overflow-y: auto;">
                          <h5>New Weightage Performance {{username}}</h5>
                          <br />
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Role<em>*</em></label>
                              <select id="ddlNewRoleType" class="form-control">
                                <option *ngFor="let item of RoleList" [value]="item.RoleID">{{ item.RoleName }}</option>
                              </select>
                            </div>
                            <div class="col-sm-12">
                              <label>Non Production</label>
                              <input id="Txt_NewNonProduction" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_NewNonProduction')" />
                            </div>
                            <div class="col-sm-12">
                              <label>Productivity Achieved<em>*</em></label>
                              <input id="Txt_NewProductivityAchieved" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_NewProductivityAchieved')" />
                            </div>
                            <p class="col-sm-12 fw-semibold pt-2">
                              <strong class="text-warning">Note:</strong> Non Production + Productivity Achieved + Occupancy + Punctuality + Attendance must equal <strong>100</strong>.
                            </p>
                            <div class="col-sm-12">
                              <label>Occupancy<em>*</em></label>
                              <input id="Txt_NewOccupancy" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_NewOccupancy')" />
                            </div>
                            <div class="col-sm-12">
                              <label>Punctuality<em>*</em></label>
                              <input id="Txt_NewPunctuality" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_NewPunctuality')" />
                            </div>
                            <div class="col-sm-12">
                              <label>Attendance<em>*</em></label>
                              <input id="Txt_NewAttendance" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_NewAttendance')" />
                            </div>
                            <div class="col-sm-12">
                              <label>Total Sum</label>
                              <input id="Txt_NewTotalSum" type="number" class="form-control" disabled />
                            </div>
                            <div class="col-sm-12">
                              <label>Daily Target Pages<em>*</em></label>
                              <input id="Txt_NewDailyTargetPages" type="number" class="form-control" />
                            </div>
                            <div class="col-sm-12">
                              <label>Comment</label>
                              <textarea id="Txt_Comment" class="form-control" rows="3" style="resize: none;"></textarea>
                            </div>
                            <div class="col-sm-12" id="Requestnote">
                              <label>Need More Info Request Note</label>
                              <textarea id="Txt_RequestNote" class="form-control" rows="3" style="resize: none;"></textarea>
                            </div>
                            <div class="col-sm-12" id="Responcenote">
                              <label>Response Note</label>
                              <textarea id="Txt_ResponceNote" class="form-control" rows="3" style="resize: none;"></textarea>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>


                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="submit" (click)="UpdateWeightageApproval()" id="btnupdate" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
